import React, { PropsWithChildren } from 'react';
import { Modifier } from '../../lib/bemUtils/Modifier';
import bem from '../../lib/bemUtils/bem';

type HTMLFormProps = React.DetailedHTMLProps<React.FormHTMLAttributes<HTMLFormElement>, HTMLFormElement>;

type Form = PropsWithChildren<{
  modifier?: Modifier<'no-padding' | 'no-padding-bottom'>;
  ref?: React.Ref<HTMLFormElement>;
}> &
Omit<HTMLFormProps, 'className'>;

export function Form({ modifier, children, ref, ...htmlFormProps }: Form) {
  return (
    <form {...htmlFormProps} ref={ref} className={bem('form2', modifier)}>
      {children}
    </form>
  );
}
